<template>
    <div class="animated fadeIn">
        <b-card>
            <Cart @onAddToCartClick="onAddToCartClick" v-model="dataProducts"></Cart>
            <b-row class="text-right">
                <b-col>
                    <b-button-group class="mt-4">
                        <b-button @click="onContinueShoppingClick" class="btn btn-light">{{Core.Definition.getDefinition('Continuer à magasiner')}}</b-button>
                        <b-button v-if="hasOptions === true" @click="onOptionsClick" class="btn btn-light">{{Core.Definition.getDefinition('Suivant')}} <i class="fa fa-chevron-right ml-2"></i></b-button>
                        <b-button v-if="hasOptions === false" @click="onCheckoutClick" class="btn btn-light">{{Core.Definition.getDefinition('Passer au paiement')}} <i class="fa fa-chevron-right ml-2"></i></b-button>
                    </b-button-group>
                </b-col>
            </b-row>
        </b-card>

        <ModalLogin
                ref="modalLogin"
                @onPasswordRecoveryClick="onPasswordRecoveryClick"
                @onCreateAccountClick="onCreateAccountClick"
                @onLoginSuccess="onLoginSuccess">
        </ModalLogin>

        <ModalCreateAccount
                @onLoginClick="onLoginClick"
                :caption="Core.Definition.getDefinition('Nouveau compte')"
                ref="modalCreateAccount">
        </ModalCreateAccount>

        <ModalPasswordRecovery
                @requestPasswordRecoverySuccess="onLoginClick"
                ref="modalPasswordRecovery">
        </ModalPasswordRecovery>
    </div>
</template>

<script>
    import Cart from '../../../components/Cart'
    import ModalLogin from '../../../components/ModalLogin'
    import ModalPasswordRecovery from '../../../components/ModalPasswordRecovery'
    import ModalCreateAccount from '../../../components/ModalCreateAccount'
    export default {
        name: 'ShopCart',
        components: {
            Request,
            Cart,
            ModalLogin,
            ModalCreateAccount,
            ModalPasswordRecovery
        },
        props: {
            productsRedirectType: {
                type: String,
                default: 'router'
            },
            productsRedirectUrl: {
                type: String,
                default: ''
            },
            checkoutRedirectType: {
                type: String,
                default: 'router'
            },
            checkoutRedirectUrl: {
                type: String,
                default: ''
            },
            productPreviewRedirectType: {
                type: String,
                default: 'router'
            },
            productPreviewRedirectUrl: {
                type: String,
                default: ''
            },
            optionsRedirectType: {
                type: String,
                default: 'router'
            },
            optionsRedirectUrl: {
                type: String,
                default: ''
            }
        },
        computed: {
            hasOptions() {
                for(let product in this.dataProducts) {
                    product = this.dataProducts[product]
                    if (Core.Validation.isId(product.formTemplateId)||Core.Product.conditionalIsEnabled(product)||Core.Product.participantModeIsEnabled(product)) {
                        return true
                    }
                }
                return false
            }
        },
        mounted() {
            Core.Session.Cart.retrieve()
            this.dataProducts = Core.Session.Cart.products
        },
        data: function () {
            return {
                Core: window.Core,
                dataProducts: [],
                dataAfterLogin: ''
            }
        },
        methods: {
            onAddToCartClick(product) {
                let append = true
                if (product.type !== Core.Product.typeStandard) {
                    append = false
                }
                Core.Session.Cart.remove(product.id)
                if (product.quantity > 0) {
                    Core.Session.Cart.add(product, append)
                }
            },
            onContinueShoppingClick() {
                switch(this.productsRedirectType) {
                    case 'router':
                        let productsRedirectUrl = this.productsRedirectUrl
                        if (productsRedirectUrl === '') {
                            productsRedirectUrl = Core.Definition.getDefinition('/commerce/boutique')
                        }
                        this.$router.push(productsRedirectUrl)
                        break
                    case 'url':
                        if (this.productsRedirectUrl!=='') {
                            window.open(this.productsRedirectUrl, '_self');
                        }
                        break
                }
            },
            onCheckoutClick() {

                if(!Core.Session.AuthUser.isAuth()) {
                    this.dataAfterLogin = 'checkout'
                    this.$refs.modalLogin.open = true
                    return
                }

                switch(this.checkoutRedirectType) {
                    case 'router':
                        let checkoutRedirectUrl = this.checkoutRedirectUrl
                        if (checkoutRedirectUrl === '') {
                            checkoutRedirectUrl = Core.Definition.getDefinition('/commerce/boutique/confirmation')
                        }
                        this.$router.push(checkoutRedirectUrl)
                        break
                    case 'url':
                        if (this.checkoutRedirectUrl!=='') {
                            window.open(this.checkoutRedirectUrl, '_self');
                        }
                        break
                }
            },
            onOptionsClick() {

                if(!Core.Session.AuthUser.isAuth()) {
                    this.dataAfterLogin = 'options'
                    this.$refs.modalLogin.open = true
                    return
                }

                switch(this.optionsRedirectType) {
                    case 'router':
                        let optionsRedirectUrl = this.optionsRedirectUrl
                        if (optionsRedirectUrl === '') {
                            optionsRedirectUrl = Core.Definition.getDefinition('/commerce/boutique/options')
                        }
                        this.$router.push(optionsRedirectUrl)
                        break
                    case 'url':
                        if (this.optionsRedirectUrl!=='') {
                            window.location.href = this.optionsRedirectUrl
                        }
                        break
                }
            },
            onLoginClick() {
                this.$refs.modalCreateAccount.open = false
                this.$refs.modalLogin.open = true
            },
            onLoginSuccess() {
                this.$refs.modalLogin.open = false
                switch(this.dataAfterLogin) {
                    case 'checkout':
                        this.onCheckoutClick()
                        break
                    case 'options':
                        this.onOptionsClick()
                        break
                }
            },
            onPasswordRecoveryClick() {
                this.$refs.modalLogin.open = false
                this.$refs.modalCreateAccount.open = false
                this.$refs.modalPasswordRecovery.open = true
            },
            onCreateAccountClick() {
                this.$refs.modalLogin.open = false
                this.$refs.modalCreateAccount.open = true
            }
        }
    }
</script>
